export default () => (
  document.head.querySelector('meta[name="csrf-token"]').content
);
